import { Html5Qrcode, Html5QrcodeScannerState, Html5QrcodeSupportedFormats } from 'html5-qrcode';
import React, { useRef } from 'react'
import { useCallback } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setScannerCameraId, setScannerOpen, setScannerResult } from '../../store/scannerSlice';
import MySpiner from '../UI/spiner/MySpiner';

const ScannerWindowPro = ({ onClickClose }) => {

    const open = useSelector(state => state.scanner.open)
	const cameraId = useSelector(state => state.scanner.cameraId)
	const result = useSelector(state => state.scanner.result)
	const dispatch = useDispatch()

    const [tempDevices, setTempDevices] = useState('')
    
    // Створюю РЕФ, щоб можна було змінювати з різних місць
    const html5Qrcode = useRef(null)
   
    // Допустимі формати для зчитування
    const formatsToSupport = [
        Html5QrcodeSupportedFormats.QR_CODE,
        // Html5QrcodeSupportedFormats.UPC_A,
        // Html5QrcodeSupportedFormats.UPC_E,
        // Html5QrcodeSupportedFormats.UPC_EAN_EXTENSION,
        Html5QrcodeSupportedFormats.CODE_128,
    ]

    // Покращення зображення
    const videoConstraints = {
        facingMode: "environment",
        width: { ideal: 1280 },
        height: { ideal: 720 },
    };
    // Налаштування
    const config = {
        // videoConstraints,
        // fps: 100,    // Optional, frame per seconds for qr code scanning
        fps: 10,    // Optional, frame per seconds for qr code scanning
        // fps: 5,    // Optional, frame per seconds for qr code scanning
        qrbox: { width: 250, height: 250 },  // Optional, if you want bounded box UI
        // formatsToSupport: formatsToSupport,
        // aspectRatio: 1
        // aspectRatio: 1.333334
        // aspectRatio: 1.777778
        // focusMode:
        disableFlip: false, // true може завадити читанню віддзеркалених QR
    }

    useEffect(() => {
        if (onClickClose) {
            closeScanner()
        }
    }, [onClickClose])

    // Отримання камери та включення
    useEffect(() => {
        // This method will trigger user permissions
        Html5Qrcode.getCameras().then(devices => {
            /**
             * devices would be an array of objects of type:
             * { id: "id", label: "label" }
             */
            // console.log('devices', devices)
            let tempDevicesText = ''
            if (devices && devices.length) {
                const cameraIdTemp = devices[0].id;
                // Зберігаю ID камери в сторі
                dispatch(setScannerCameraId(cameraIdTemp))
                // setCameraId(cameraIdTemp)
                // .. use this to start scanning.

                for (const device of devices) {
                    tempDevicesText += `ID: ${device.id}, \nname: ${device.label}\n`
                }
            }

            setTempDevices(tempDevicesText)
        }).catch(err => {
            // handle err
        });
    }, [])

    useEffect(() => {
        // Це потрібно було без рефу
        // const html5QrCode = new Html5Qrcode(/* element id */ "reader");

        // Тут перевірямо. Якщо немає ще рефу, то створюємо сканер
        if (!html5Qrcode.current) {
            html5Qrcode.current = new Html5Qrcode('reader')
        }

        if (cameraId && open) {
            // Скидаємо результат
            dispatch(setScannerResult(''))

            // Так було без рефу
            // html5QrCode.start(

            // Старт сканера з рефу
            html5Qrcode.current.start(
                // cameraId, // Або Id камери або те, що нижче. Але те, що нижче поки не тестував
                // { facingMode: "user" }, // If you want to prefer front camera 
                { facingMode: "environment" }, // If you want to prefer back camera
                // { facingMode: { exact: "user"} }, // Select front camera or fail with `OverconstrainedError`.
                // { facingMode: { exact: "environment"} }, // Select back camera or fail with `OverconstrainedError`.
                config,
                (decodedText, decodedResult) => {
                    console.log(`Code matched = ${decodedText}`, decodedResult);
                    // Закриваємо вікно
                    dispatch(setScannerOpen(false))
                    // Зберігаємо результат
                    dispatch(setScannerResult(decodedText))
                    // Завершуємо сканер
                    html5Qrcode.current.stop()
                    // do something when code is read
                },
                (errorMessage) => {
                    // Тут можна відловити помилки. Але вони зʼявляються постійно поки сканер ловить код
                    // console.log('errorMessage', errorMessage)
                    // parse error, ignore it.
                }
            )
            .catch((err) => {
                // Start failed, handle it.
            });

            // const stateScanner = html5Qrcode.current?.getState()
            // if (stateScanner === Html5QrcodeScannerState.SCANNING) {
            //     // wait 2 seconds to guarantee the camera has already started to apply the focus mode and zoom...
            //     setTimeout(function () {
            //         html5Qrcode.current.applyVideoConstraints({
            //             focusMode: "continuous",
            //             advanced: [{ zoom: 2.0 }],
            //         });
            //     }, 2000);
            // }
        } else if (!open) { // Якщо закривається модальне вікно, то вимикаємо включений сканер
            closeScanner()
        }
    }, [cameraId, open])

    const closeScanner = () => {
        // отримуємо стан сканеру зараз. Наприклад "2" = "сканування"
        const stateScanner = html5Qrcode.current?.getState()
                    
        // Якщо стан сканування і він ще досі не закритий успіхом, то завершуємо примусово
        // console.log('stateScanner', stateScanner)
        // console.log('Html5QrcodeScannerState.SCANNING', Html5QrcodeScannerState.SCANNING)
        if (stateScanner === Html5QrcodeScannerState.SCANNING) {
            html5Qrcode.current.stop()
        }
    }

  return (
    <>
        {
            // tempDevices
        }
        <div id="reader">
            <MySpiner />
        </div>
    </>
  )
}

export default ScannerWindowPro